// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from 'react';
import './MSTabApp.css';
import * as microsoftTeams from "@microsoft/teams-js";
import { whiteboardChatHomeURL } from './App.js';
import clsx from 'clsx';
import AuthDialog from './AuthDialog';
// import { Provider, themes } from '@fluentui/react-northstar' //https://fluentsite.z22.web.core.windows.net/quick-start

/**
 * The 'Config' component is used to display your group tabs
 * user configuration options.  Here you will allow the user to 
 * make their choices and once they are done you will need to validate
 * thier choices and communicate that to Teams to enable the save button.
 */
function TabConfig(props) {
    const [context, setContext] = React.useState(null);

    React.useEffect(() => {
      /**
       * The content url for the tab is a required value that must be set.
       * The url value is the source url for your configured tab.
       * This allows for the addition of query string parameters based on
       * the settings selected by the user.
       */
      // microsoftTeams.settings.setSettings({"contentUrl": "https://localhost:3000/tab"});
      microsoftTeams.settings.setSettings({
        "contentUrl": whiteboardChatHomeURL+"/tab",
        "suggestedDisplayName": "Whiteboard.chat"
      });
      microsoftTeams.getContext(c => { console.log("CONTEXT = ", c); setContext(c); })
      /**
       * After verifying that the settings for your tab are correctly
       * filled in by the user you need to set the state of the dialog
       * to be valid.  This will enable the save button in the configuration
       * dialog.
       */
      microsoftTeams.settings.setValidityState(true);
    }, []);
  
    return (
        <div className={clsx("MSTeamsSignInBg", (context && context.theme === "dark" ? "cfgBgThemeDark" : "cfgBgThemeLight"))}>
          <div className="wbc_banner">
          { (context && context.theme === "dark") ?
            <img alt="Whiteboard.chat splash" width="480px" src="wbc_modal_dark_banner.png"></img> : null }
          { (context && context.theme === "default") ?
            <img alt="Whiteboard.chat splash" width="480px" src="wbc_modal_default_banner.png"></img> : null }
          </div>
          <div style={{ marginTop: '-10px', marginLeft: '10px', marginRight: '10px', fontSize: "1em", lineHeight: "1.2em" }}>
          <b>Whiteboard.chat</b> - The online Observability, Engagement and Collaboration Platform. 
          Developed completely with feedback from Teachers around the world. Includes manipulatives, tools and
          class controls essential for every online remote, hybrid or in-person classroom.
          </div>
          {/* <br/>
          <div>
            Select <b>Save</b> to add a Whiteboard.chat tab to your Channel or Chat.
          </div> */}
        </div>
    );
  }

  export default TabConfig;